<div class="wrapper">
  <span class="label label--heading">Filters: </span>
  <span *ngIf="!filters.length"
        class="label">None</span>
  <span *ngIf="filters.length"
        class="label label--applied">Applied</span>
  <mat-chip-listbox class="filters">
    <mat-chip *ngFor="let filter of filters"
              class="filters__item"
              [disableRipple]="true"
              (removed)="remove(filter)">
      {{filter.label}}: {{filter.value}}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-listbox>
  <button *ngIf="filters.length"
          mat-button
          (click)="clear()">CLEAR</button>
</div>
